import Cache from "@/cache/product.js";     //引入商品缓存，用于存放商品编辑的内容和数据结构
import Api from '@/script/api';
import { Message } from 'element-ui'
import Vue from 'vue';
import { fetchDouDianAccounts } from '@/script/doudianLocalLogin';

const state = {
    copyConfig: getBaseConfig('cache/publish.json'),
    readConfig: getBaseConfig(),
    copyLog: [],

    copyLinkValue: "",  //要抓取的链接
    product: [],        //宝贝列表
    jumpProduct: [],    //跳过列表

    loading: false,                 //显示加载状态
    editIndex: -1,                  //编辑的宝贝索引
    lastEditIndex: null,             //上一次编辑的索引
    hasEdited: false,               //编辑的宝贝对象
    cacheDetail: null,              //缓存文件里面的详情，用于编辑商品的时候

    startTimestamp: null,           // 记录开始时间戳
    copyTime: 0,                    //总的上架时间

    //图片选择器对象
    imgSelect: {
        show: false,                //显示模态框
        filed: null,                //当前操作的字段
        type: 'add'                 //操作类型，add：增加，reset：编辑
    },

    selectShop: "",                 //选择的店铺 
    shopList: [],                   //店铺列表 用于抓取和上架
    copyShopIds: [],                //上架商品的店铺id列表

    readLinkUrls: [],               //要抓取的链接
    copyProductIds: [],             //要抓取的关系表id
}

const mutations = {
    //更新状态值
    updateState(state, value) {
        state.copyConfig.STATE = value;
    },
    //更新上架商品信息
    updatePublishProduct(state, product) {
        // 更新商品状态信息（如果有）
        if (product?.id > 0) {
            const index = state.product.findIndex(p => p.id === product.id);
            if (index === -1) return;

            const targetProduct = state.product[index];

            const { shopid, status, msg, shop_name, product_id } = product;
            const newStatus = { status, msg, shopid, shop_name, product_id };

            const oldList = targetProduct.statusList || [];
            const statusIndex = oldList.findIndex(s => s.shopid === shopid);

            let newStatusList = [];

            // 更新商品信息
            if (statusIndex > -1) {
                // 更新已有项
                newStatusList = [
                    ...oldList.slice(0, statusIndex),
                    { ...oldList[statusIndex], ...newStatus },
                    ...oldList.slice(statusIndex + 1)
                ];
            } else {
                // 添加新项
                newStatusList = [...oldList, newStatus];
            }
            // 👇 Vue.set 替换整个 product（确保虚拟滚动器能检测到变化）
            Vue.set(state.product, index, {
                ...targetProduct,
                statusList: newStatusList,
            });
        }
    },
    //更新状态值
    wangUpdateState(state, value) {
        state.readConfig.STATE = value;
    },
    //更新统计信息
    updateCount(state, input) {
        // 更新统计信息
        const { successCount, failCount, allCount } = input;

        state.copyConfig.SUCCESS_ACOUNT = successCount;
        state.copyConfig.FAIL_ACOUNT = failCount;
        state.copyConfig.TOTAL = allCount;
        state.copyConfig.AWAIT_ACOUNT = allCount - successCount - failCount;


    },
    updateWangCount(state, input) {
        // 更新统计信息
        const { successCount, failCount, allCount, product } = input;

        state.readConfig.SUCCESS_ACOUNT = successCount;
        state.readConfig.FAIL_ACOUNT = failCount;
        state.readConfig.TOTAL = allCount;
        state.readConfig.AWAIT_ACOUNT = allCount - successCount - failCount;
        // console.log("read product", product)
        // 更新商品状态信息（如果有）
        if (product?.id > 0) {
            const targetProductIndex = state.product.findIndex(p => p.id === product.id);
            if (targetProductIndex > -1) {
                state.product[targetProductIndex] = { ...state.product[targetProductIndex], ...product }
            } else {
                state.product.push(product)
            }
        }
    },
    jumpproduct(state, input) {
        // 更新统计信息
        const { successCount, failCount, allCount, product } = input;

        state.readConfig.SUCCESS_ACOUNT = successCount;
        state.readConfig.FAIL_ACOUNT = failCount;
        state.readConfig.TOTAL = allCount;
        state.readConfig.AWAIT_ACOUNT = allCount - successCount - failCount;

        // 更新商品状态信息（如果有）
        if (product?.id > 0) {
            state.jumpProduct.push(product)
        }
    },
    jumpproductV2(state, product) {
        // 更新商品状态信息（如果有）
        if (product?.id > 0) {
            state.jumpProduct.push(product)
        }
    },

    //上架日志---字符串文本
    writeCopyLog(state, msg) {
        state.copyLog.push(msg);
    },


    // 修改输入的值，确保刷新页面不会不见
    SET_COPYLINK_VALUE(state, value) {
        state.copyLinkValue = value;
    },
    RESET_PRODUCT_DATA(state) {
        state.copyConfig = getBaseConfig('cache/publish.json');
        state.readConfig = getBaseConfig();

        state.editIndex = -1;
        state.cacheDetail = null;
        state.product = [];
        state.jumpProduct = [];
        state.copyLog = [];

        state.readLinkUrls = [];
        state.copyProductIds = [];
        // 清楚product里面的数据结构缓存
        Cache.clear();
    },
    UPDATE_PRODUCT_BY_ID(state, { id, result }) {
        let findIndex = state.product.findIndex(item => item.id == id);
        if (findIndex > -1) {
            state.product[findIndex].title = result.title;
            state.product[findIndex].classify_str = result.classify_str;
            state.product[findIndex].update_time = Date.now(); // 更新编辑时间
        }
    },
    // 删除单条记录
    REMOVE_PRODUCT(state, index) {
        let pro = state.product[index];
        Cache.delete(pro.id);
        state.product.splice(index, 1);

        // 如果删除的是当前编辑的商品，就清除当前编辑的商品
        if (index == state.editIndex) {
            state.editIndex = -1;
            state.cacheDetail = null
        }
    },
    // 修改商品类目
    UPDATE_PRODUCT_CATE(state, { index, data, data_format }) {
        if (index > -1 && state.product[index]?.classify_str) {
            // 修改分类
            state.product[index].classify_str = data_format.c_path.join(">");
        }
    },
    // 批量应用到未匹配的商品类目
    UPDATE_PRODUCT_UNSETCATE(state, { data, data_format }) {
        // 过滤出所有未匹配的商品类目，然后循环修改设置类目

    },
    // 设置编辑序列
    SET_EDIT_INDEX(state, index) {
        // 判断上一次编辑的id是否存在
        if (state.editIndex) {
            state.lastEditIndex = state.editIndex;
        }
        state.editIndex = index;
    },
    UPDATE_LOADING(state, value) {
        state.loading = value
    },
    SET_CACHE_DETAIL(state, data) {
        state.cacheDetail = JSON.parse(JSON.stringify(data)); //对数据进行拷贝
        // console.log("当前操作的临时文件：", state.cacheDetail);
    },
    // 显示图片选择器 ，并且记录当前选择的字段值,以及操作
    SHOW_IMAGE_SELECT_AND_SET_FILED(state, { filed, type }) {
        state.imgSelect = {
            show: true,
            filed,
            type
        }
    },
    // 统一修改字段值， 格式 path = 'product.0.images' value = any
    UPDATE_FILED_VALUE(state, { path, value, type = 'reset' }) {
        // console.log("UPDATE_FILED_VALUE", path, value, type);
        const keys = path.split('.');

        let current = state;

        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];
            if (current?.[key]) {
                current = current[key];
            }
        }

        if (type == "reset") {
            current[keys[keys.length - 1]] = value;
        } else if (type == "add") {
            current[keys[keys.length - 1]].push(value);
        }
    },
    SET_COPY_TIME(state, value) {
        state.copyTime = value;
    },
    SET_COPY_START_TIMESTAMP(state, ts) {
        state.startTimestamp = ts;
    },
    SET_SHOP_LIST(state, data) {
        state.selectShop = ""; // 清空选择的店铺
        // 如果数据不是数组，就转化为数组
        state.shopList = data || [];
    },
    SET_SELECT_SHOP(state, id) {
        state.selectShop = id;
    },
    SET_COPY_SHOP_IDS(state, ids) {
        state.copyShopIds = ids;
    }
};

const actions = {
    async getDetailProduct({ state, commit, dispatch }, index) {
        if (index < 0) return;
        try {
            commit('SET_EDIT_INDEX', index);
            // 开启加载动画
            commit('UPDATE_LOADING', true);
            let pro = state.product[index];
            // 如果存在缓存的话
            if (Cache.has(pro.id)) {
                commit('UPDATE_LOADING', false);
                commit('SET_CACHE_DETAIL', {
                    ...pro,
                    ...Cache.get(pro.id)
                })
                return;
            }
            // 不存在就去远程请求数据
            let res = await dispatch('getDetailProductByApi', pro.id);
            if (res.code == 1 && res.info?.attr_json) {
                const source_json_data = JSON.parse(res.info.source_json_data);

                // 判断白底图
                if (!source_json_data?.white_background_image) {
                    source_json_data.white_background_image = [];
                }
                if (!source_json_data?.main_images_3_4) {
                    source_json_data.main_images_3_4 = [];
                }
                const tempData = {
                    ...pro,
                    attr_json: JSON.parse(res.info.attr_json),
                    change_attribute_json: JSON.parse(res.info.change_attribute_json),
                    source_json_data
                }
                commit('SET_CACHE_DETAIL', tempData);

                Cache.set(pro.id, tempData);
            } else {
                Message.error(res.err || res.msg || "出错了！");
            }

            commit('UPDATE_LOADING', false);
        } catch (e) {

        } finally {
            // 即使返回了，也会执行
            dispatch("nextPreload")
        }
    },
    // 预加载下一个
    async nextPreload({ dispatch, state }) {
        // 如果当前编辑的索引是最后一个，就不再预加载
        if (state.editIndex >= state.product.length - 1) {
            return;
        }
        let nextPro = state.product[state.editIndex + 1];
        // 如果存在缓存的话
        if (Cache.has(nextPro.id)) {
            // 直接返回
            return;
        }
        // 预加载下一个商品
        let res = await dispatch('getDetailProductByApi', nextPro.id);
        if (res.code == 1 && res.info?.attr_json) {
            const source_json_data = JSON.parse(res.info.source_json_data);

            // 判断白底图
            if (!source_json_data?.white_background_image) {
                source_json_data.white_background_image = [];
            }
            if (!source_json_data?.main_images_3_4) {
                source_json_data.main_images_3_4 = [];
            }
            const tempData = {
                ...nextPro,
                attr_json: JSON.parse(res.info.attr_json),
                change_attribute_json: JSON.parse(res.info.change_attribute_json),
                source_json_data
            }

            Cache.set(nextPro.id, tempData);
            // console.log("预加载下一个商品：", nextPro.id, tempData);
        } else {
            Message.error(res.err || res.msg || "出错了！");
        }

    },
    // 开始读取赋值url
    async startReadProduct({ state, commit, dispatch }) {
        // 避免重复点击
        if (![0, 4, 5].includes(state.readConfig.STATE)) {
            return;
        }
        let defaultAccount = await dispatch('checkDefaultAccount');
        if (!defaultAccount) {
            return
        }
        if (!state.selectShop) {
            Message.error("请选择抓取店铺");
            return;
        }

        // 新调整
        // commit('RESET_PRODUCT_DATA');   // 初始化数据
        // const lines = state.copyLinkValue.split('\n').map(line => line.trim()).filter(Boolean); // 格式化要抓取的连接，合并成数组
        // const uniqueMap = new Map();
        // for (const url of lines) {
        //     const match = url.match(/[?&]id=(\d+)/);
        //     if (match) {
        //         const id = match[1];
        //         if (!uniqueMap.has(id)) {
        //             uniqueMap.set(id, url);
        //         }
        //     }
        // }
        // state.readLinkUrls = Array.from(uniqueMap.values());
        // if (state.readLinkUrls.length == 0) {
        //     Message.error("请输入正确的商品链接！");
        //     return;
        // }
        // commit('UPDATE_FILED_VALUE', { path: 'readConfig.TOTAL', value: state.readLinkUrls.length }); // 统计数量
        // commit('UPDATE_FILED_VALUE', { path: 'readConfig.STATE', value: 1 }); // 标记开始执行

        // 初始化数据
        commit('RESET_PRODUCT_DATA');
        commit('UPDATE_FILED_VALUE', { path: 'readConfig.STATE', value: 5 });
        
        try {
            let res = await Api.post("/admintooltaobaoaccount/addgoodsurl", { url_str: state.copyLinkValue, sys_shop_id: state.selectShop });
            if (res.code == 1) {
                // 只有状态是5， 准备开始执行，才执行
                if (state.readConfig.STATE == 5) {
                    commit('UPDATE_FILED_VALUE', { path: 'readConfig.STATE', value: 1 });
                    commit('UPDATE_FILED_VALUE', { path: 'readConfig.TOTAL', value: res.info || 0 });
                }
            } else {
                Message.error(res.err || res.msg || "出错了！");
            }
        } catch (e) {
            commit('UPDATE_FILED_VALUE', { path: 'readConfig.STATE', value: 0 });
            Message.error("执行过程中出现错误：" + e.message);
        }
    },
    async startCopyProduct({ commit, dispatch }, { goodsids, shopids }) {
        let defaultAccount = await dispatch("checkDefaultAccount");
        if (!defaultAccount) {
            return
        }
        commit('UPDATE_FILED_VALUE', { path: 'copyConfig.STATE', value: 5 });
        try {
            let res = await Api.post("/admintooltaobaoaccount/addgoodsrel", { dou_goods_publish_ids: goodsids, dou_sys_shop_id: shopids })
            if (res.code == 1) {
                const value = {
                    ...getBaseConfig(),
                    STATE: 1
                };
                commit('UPDATE_FILED_VALUE', { path: 'copyConfig', value });
            } else {
                Message.error(res.err || res.msg || "出错了！");
            }
        } catch (e) {
            commit('UPDATE_FILED_VALUE', { path: 'copyConfig.STATE', value: 0 });
            Message.error("执行过程中出现错误：" + e.message);
        }
    },
    async getDetailProductByApi({ commit }, id) {
        return Api.post("/admintooltaobaoaccount/goodsdetails", { id })
    },
    async updateProductDetail({ commit }, data) {
        // 如果当前编辑的商品被删除的情况下
        if (!data?.id) {
            return;
        }
        const source_json_data = {
            ...data.source_json_data,
            title: data.title
        }
        const pramas = {
            id: data.id,
            change_attribute_json: JSON.stringify(data.change_attribute_json),
            source_json_data: JSON.stringify(source_json_data),
            source_title: data.title,
        }

        let res = await Api.post("/admintooltaobaoaccount/goodsdetailsedit", pramas)
        if (res.code == 1) {
            // 重新设置值，避免读取缓存数据读到旧数据
            Cache.set(data.id, data);

            commit("UPDATE_PRODUCT_BY_ID", {
                id: data.id,
                result: {
                    title: data.title,
                    classify_str: data.classify_str
                }
            })
        } else {
            Message.error(res.err || res.msg || "出错了！");
        }
        return true;
    },
    async checkDefaultAccount() {
        let res = await Api.post("/admintooltaobaoaccount/getdefaultaccount");
        if (res.code) {
            return true;
        } else {
            Message.error("请先设置默认店铺");
        }
        return false;
    },
    async getShopList({ commit, state }, refresh) {
        if (state.shopList.length > 0 && !refresh) {
            return; // 如果已经有店铺列表了，就不再请求
        }
        let res = await fetchDouDianAccounts(Api.post.bind(Api), {
            requireLogin: true,
            status: 1,
            pageSize: 1000,
        });
        if (res.code == 1) {
            commit('SET_SHOP_LIST', res.list || []);
        }
    }
};

const getters = {
    getOnOff(state) {
        return state.copyConfig.STATE
    },
    getWangOnOff(state) {
        return state.readConfig.STATE
    },
    getWangConfig() {
        return state.readConfig
    },
};

//  创建基础配置
function getBaseConfig(fileName) {
    return {
        SUCCESS_ACOUNT: 0,          //成功条数
        FAIL_ACOUNT: 0,             //失败条数
        AWAIT_ACOUNT: 0,            //等待条数
        TOTAL: 0,                   //总的条数
        STATE: 0,                   //1 准备开始 2 运行中 3点击暂停 0.未开始 4.完成, 5点击开始
        FILE_NAME: fileName || "",  //文件名 读取文件 read  复制文件copy
    }
}

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
